//@ts-nocheck

import React from 'react'

import { Heading, Paragraph } from '../../../atoms/Typography/Typography.component'
import { Col, SpacerBase } from '../../../atoms/GridSystem'
import Button from '../../../atoms/Button/Button.component'
import ItemsGrouped from '../../../molecules/ItemsGrouped/ItemsGrouped.component'

import * as S from '../Text.styles'

interface TextHeadingLightProps {
  preTitle?: {
    as: 'p'
    typo: string
    content: string
  }
  sectionTitle?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    typo: string
    content: string
  }
  subtitle?: {
    as: 'p'
    typo: string
    content: string
  }
  alignment?: 'left' | 'center'
  ctaPrimary?: {
    label: string
    [key: string]: any
  }
  ctaSecondary?: {
    label: string
    [key: string]: any
  }
}

const TextHeadingLight: React.FC<TextHeadingLightProps> = ({ preTitle, sectionTitle, subtitle, alignment, ctaPrimary, ctaSecondary }) => {
  return (
    <S.RowTextHeading alignment={alignment}>
      <Col xs={12} lg={6} $direction="column" $offset={{ xs: 0, lg: alignment == 'center' ? 3 : 0 }} align={alignment == 'center' ? 'center' : 'flex-start'}>
        {preTitle ? (
          <>
            <Paragraph {...preTitle} />
            <SpacerBase xs={1} />
          </>
        ) : null}
        {sectionTitle ? (
          <>
            <Heading as={sectionTitle.as} typo={sectionTitle.typo} fontPrimary>
              {sectionTitle.content}
            </Heading>
            <SpacerBase xs={1} />
          </>
        ) : null}
        {subtitle ? <Paragraph {...subtitle} /> : null}
        {ctaPrimary || ctaSecondary ? (
          <>
            <SpacerBase xs={4} />
            <ItemsGrouped direction={{ xs: "column", lg: "row" }} space={{ xs: 16, lg: 24 }} fullWidth={['xs', 'sm', 'md']}>
              {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" /> : null}
              {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" /> : null}
            </ItemsGrouped>
          </>
        ) : null}
      </Col>
    </S.RowTextHeading>
  )
}

export default TextHeadingLight
